// extracted by mini-css-extract-plugin
export default {"iconsContainer":"iconsContainer-KTzqj","tests":"tests-v6iud","vector":"vector-PxzYH","students":"students-EPUWr","cardTemplate":"cardTemplate-lTZrN"};